<template>
  <div>
    <v-snackbar
      v-if="currentMessage"
      v-model="snackbar"
      :top="true"
      :color="currentColor"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
    >
      {{ currentMessage.message }}
      <v-btn dark flat @click="shiftMessage()">{{ $t('close') }}</v-btn>
    </v-snackbar>
  </div>
</template>

<i18n>
  {
    "de": {
      "close": "Schließen"
    },
    "en": {
      "close": "Close"
    }
  }
</i18n>

<script>
import { mapActions, mapGetters } from "vuex";

// import { api } from "@/store/modules/configuration";
import { api as appApi } from "@/store/modules/app";

export default {
  data() {
    return {
      mode: "",
      timeout: 5000,
      snackbar: false,
      currentMessage: {}
    };
  },
  computed: {
    ...mapGetters(appApi.namespace, [appApi.getters.getMessageline]),
    messageline() {
      return this.getMessageline;
    },
    currentColor() {
      if (this.currentMessage.type == "error") {
        return "red";
      } else if (this.currentMessage.type == "success") {
        return "green";
      } else {
        return "secondary";
        // return "grey";
      }
    }
  },
  methods: {
    ...mapActions(appApi.namespace, [appApi.actions.shiftStatus]),
    shiftMessage() {
      const newMessage = this.getMessageline[0];
      this.currentMessage = newMessage;
      this.snackbar = true;
      this.shiftStatus();
    }
  },
  watch: {
    currentStatus() {
      if (this.currentStatus != false) {
        this.snackbar = true;
      }
    },
    async snackbar(visible) {
      if (visible || !this.messageline.length) return;
      await this.$nextTick();
      setTimeout(() => {
        this.shiftMessage();
      }, 500);
    },
    messageline() {
      if (!this.snackbar) {
        this.shiftMessage();
      }
    }
  }
};
</script>
